import { createApp } from 'vue';
import { createHead } from '@vueuse/head';
import App from '@app/App.vue';

import '@shared/styles/_conf.scss';
import store from '@shared/store/index.js';
import router from '@shared/routers/index.js';

import { loadYandexMetrika } from '@shared/libraries/yandexMetrika/yandexMetrika';
import { PROJECT_KEYS } from '@shared/constants/keys/keys';

// Подавляем нативный баннер установки PWA (Chrome/Android):
// без preventDefault он «прыгает» обратно при свайпе вниз.
// Собственный UI установки намеренно не показываем.
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
});

const app = createApp(App);

const head = createHead();
app.use(head);

app.use(store);
app.use(router);

loadYandexMetrika(PROJECT_KEYS.YANDEX_METRIKA_KEY);

app.mount('#app');

// Блокировка печати
const printOverlay = document.createElement('div');
printOverlay.id = 'print-block-overlay';
printOverlay.textContent = 'Печать документа заблокирована администратором';
document.body.appendChild(printOverlay);

window.addEventListener('beforeprint', () => printOverlay.classList.add('active'));
window.addEventListener('afterprint', () => printOverlay.classList.remove('active'));

document.addEventListener('keydown', (e) => {
	if ((e.ctrlKey || e.metaKey) && e.code === 'KeyP') {
		e.preventDefault();
	}
});

// Пререндеринг
/* document.dispatchEvent(new Event('render-event'));
 */